import React, { useCallback, useMemo } from 'react';
import { useParams, withRouter } from 'react-router-dom';
import { CatalogForm } from '../../../../components/CatalogForm/CatalogForm';
import { Validators } from '../../../../components/CatalogForm/validators';
import { ClienteService } from '../../../../services/ClienteService';

export const ClienteRepLegal = ({ match, id: propId, onSave }) => {
  const routeParams = useParams() || {};
  const clientId = propId || match?.params?.id || routeParams?.id;

  const loadClientData = useCallback(async () => {
    if (!clientId) return null;
    try {
      const data = await ClienteService.obtenerDetalleCompleto(clientId);
      if (!data) return null;

      return {
        cliente_rl_paterno: data.cliente_rl_paterno || '',
        cliente_rl_materno: data.cliente_rl_materno || '',
        cliente_rl_nombre: data.cliente_rl_nombre || '',
        cliente_rl_rfc: data.cliente_rl_rfc || '',
        cliente_rl_curp: data.cliente_rl_curp || '',
      };
    } catch (e) {
      console.error('Error al cargar datos del representante legal', e);
      return null;
    }
  }, [clientId]);

  const fields = useMemo(
    () => [
      {
        name: 'section_rep_legal',
        label: 'Datos de Identificación del Representante Legal',
        type: 'section',
        col: 12,
      },
      {
        name: 'cliente_rl_paterno',
        label: 'Apellido Paterno',
        type: 'text',
        col: 4,
        required: true,
        validators: [Validators.required('El apellido paterno es requerido')],
        placeholder: 'Primer apellido',
      },
      {
        name: 'cliente_rl_materno',
        label: 'Apellido Materno',
        type: 'text',
        col: 4,
        required: true,
        validators: [Validators.required('El apellido materno es requerido')],
        placeholder: 'Segundo apellido',
      },
      {
        name: 'cliente_rl_nombre',
        label: 'Nombre(s)',
        type: 'text',
        col: 4,
        required: true,
        validators: [Validators.required('El nombre es requerido')],
        placeholder: 'Nombre(s)',
      },
      {
        name: 'cliente_rl_rfc',
        label: 'RFC',
        type: 'text',
        col: 6,
        required: true,
        validators: [Validators.required('El RFC del representante es requerido')],
        placeholder: '13 caracteres (física)',
      },
      {
        name: 'cliente_rl_curp',
        label: 'CURP',
        type: 'text',
        col: 6,
        required: true,
        validators: [Validators.required('La CURP es requerida')],
        placeholder: '18 caracteres',
      },
    ],
    []
  );

  const handleSubmit = useCallback(
    async (values) => {
      const payload = {
        id: clientId,
        ...values,
      };
      return await ClienteService.guardar(payload);
    },
    [clientId]
  );

  const handleSuccess = useCallback(
    (response) => {
      if (onSave) {
        onSave(response);
      }
    },
    [onSave]
  );

  return (
    <div className="space-y-4">
      <CatalogForm
        title="Representante Legal"
        subtitle="Datos de personalidad jurídica y facultades legales del cliente"
        fields={fields}
        id={clientId}
        loadData={loadClientData}
        onSubmit={handleSubmit}
        onSuccess={handleSuccess}
        submitButtonText="Guardar Representante Legal"
      />
    </div>
  );
};

export default withRouter(ClienteRepLegal);
